function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var YoutubeInitStreamTemplate = require('./yt-client-init-stream.template');
var SaitoOverlay = require('./../../../lib/saito/ui/saito-overlay/saito-overlay');
var YoutubeInitStream = /*#__PURE__*/function () {
  function YoutubeInitStream(app, mod) {
    _classCallCheck(this, YoutubeInitStream);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
  }
  return _createClass(YoutubeInitStream, [{
    key: "render",
    value: function render() {
      this.overlay.show(YoutubeInitStreamTemplate(this.app, this.mod));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var this_self = this;
      if (document.getElementById('yt-stream-btn')) {
        document.getElementById('yt-stream-btn').onclick = function (e) {
          var _document$getElementB;
          var stream_key = (_document$getElementB = document.getElementById('yt-stream-identifier')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value;
          //let stream_type = document.querySelector('input[name=stream_type]:checked').value;;

          if (stream_key != '') {
            // console.log({
            // 	stream_key: stream_key,
            // 	stream_type: stream_type
            // });

            this_self.app.connection.emit('saito-yt-start-stream', {
              stream_key: stream_key
              //stream_type: stream_type
            });
            this_self.overlay.close();
            this_self.app.options.youtube = {};
            this_self.app.options.youtube.stream_key = stream_key;
            this_self.app.storage.saveOptions();
          } else {
            salert('Please provide a valid stream key');
          }
        };
      }
    }
  }]);
}();
module.exports = YoutubeInitStream;